import React from 'react';
import LinearText from '../linear-text/linear-text';

// Định nghĩa các props mà component sẽ nhận
interface ShowcaseCardProps {
    title?: string;
    headline: string;
    description?: React.ReactNode;
}

const ShowcaseCard: React.FC<ShowcaseCardProps> = ({title, headline, description}) => {
    return (
        // Lớp bọc ngoài: Cập nhật shadow tại đây
        <div
            className="rounded-2xl w-full h-auto sm:w-[346px] sm:min-h-[115px] md:!h-[176px] md:!w-[376px] p-1
                 bg-[linear-gradient(290.93deg,#DABA03_18.72%,#FFF04D_37.08%,#FFFDBD_43.79%,#CEAF00_57.39%,#FFFDBD_66.64%,#FFE659_77.01%)]
                 shadow-[0px_15px_13px_0px_#001EB780]" // <-- SHADOW ĐÃ ĐƯỢC CẬP NHẬT
        >
            {/* Card nội dung: Nền (background) */}
            <div
                className="h-full w-full flex flex-col items-center justify-center space-y-2 rounded-xl md:py-4 text-center
                   bg-[linear-gradient(to_right,#E5FFFD,#F6E989)] px-[15px] md:!px-0 py-2">
                {title && <h2 className="text-lg md:text-2xl font-bold text-[#4c1d95]">{title}</h2>}

                <LinearText as="h1" className="font-kpz_font text-lg md:text-2xl md:whitespace-pre-line font-extrabold pt-2">
                    {headline}
                </LinearText>

                {description && <p className="font-montserrat text-[16px] text-gray-800">{description}</p>}
            </div>
        </div>
    );
};

export default ShowcaseCard;
